import { IterationSchema } from '@rhythmic/types'
import type { CollectionBuildRequestConfig } from '../CollectionRegistry/CollectionBuilder.types'

export const TEAM_ITERATION_TABLE = '"public"."teamIterations"'

export const TeamIterationConfig: CollectionBuildRequestConfig = {
  collectionType: 'electric',
  table: TEAM_ITERATION_TABLE,
  partitionKey: 'team_id',
  key: 'id',
  apiEndpoint: '/api/iterations',
  where: {},
  schema: IterationSchema,
}
